import React, { useState, useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { toggleMenu, listMenu } from '../../_actions'
import { useWindowSize } from '../../_helpers'
import {
    Image,
    devices,
    minDevices,
    colors,
    UpperHeader,
    Button,
    LeftArrow,
    MobileLogo,
    Logo,
} from '../Common'

const Hamburger = ({ menuOpen, openMenuPanel }) => (
    <MenuButton role='button' open={menuOpen} onClick={openMenuPanel}>
        <div>
            <div />
            <div />
            <div />
        </div>
    </MenuButton>
)


export const Nav = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { menu, menuOpen } = useSelector(state => state.content)
    const { width } = useWindowSize()
    const mobile = width < 480

    const [activeMenu, setActiveMenu] = useState(menu)
    const [menuTitle, setMenuTitle] = useState('Menu')
    const [activeImage, setActiveImage] = useState(null)
    const [menuStack, setMenuStack] = useState([])

    useEffect(() => {
        dispatch(listMenu())
    }, [])

    const openMenuPanel = () => {
        dispatch(toggleMenu(!menuOpen))
        document.body.style.overflow = menuOpen ? 'visible' : 'hidden'
    }

    // close individual menuItem
    const changeLocation = location => e => {
        e.preventDefault()
        if (!location) return
        if (location !== history.location.pathname) {
            history.push(location)
        }
        closePanel()
    }

    // Hide the entire side menu
    const closePanel = () => {
        dispatch(toggleMenu(false))
        setMenuStack([])
        setMenuTitle('Menu')
        setActiveMenu(menu)
        document.body.style.overflow = 'visible'
    }

    const menuDown = (menuItem) => {
        menuStack.push(menuItem)
        setMenuStack(menuStack)
        setActiveMenu(menuStack[menuStack.length - 1].children)
        setMenuTitle(menuStack[menuStack.length - 1].title)
    }

    const menuUp = () => {
        menuStack.pop()
        setMenuStack(menuStack)
        setActiveMenu(menuStack.length ? menuStack[menuStack.length - 1].children : menu)
        setMenuTitle(menuStack.length ? menuStack[menuStack.length - 1].title : 'Menu')
    }

    const NavItems = ({ list }) => list.map(item =>
        <NavItem
            key={item.title}
            as={item.children.length === 0 ? Link : ''}
            to={item.children.length === 0 ? item.linked_page : ''}
            onClick={item.children.length === 0 ? changeLocation(item.linked_page) : () => menuDown(item)}
            onMouseEnter={() => item.first_image !== null ? setActiveImage(item.first_image) : ''}
        >
            {item.title}
        </NavItem>
    )

    return (
        <NavigationWrap>
            <OuterContainer>
                {!mobile ?
                    <Hamburger menuOpen={menuOpen} openMenuPanel={openMenuPanel} />
                    : !menuOpen ?
                        <Hamburger menuOpen={menuOpen} openMenuPanel={openMenuPanel} />
                        : <CloseButton role='button' aria-label='Close Menu' onClick={closePanel} />
                }
                <Logo onClick={changeLocation('/')} />
            </OuterContainer>
            <InnerContainer>
                <ButtonContainer>
                    {!mobile && <CloseButton role='button' aria-label='Close Menu' onClick={closePanel} />}
                    {menuStack.length ? <BackButton onClick={menuUp}> <LeftArrow /> PREVIOUS SCREEN</BackButton> : ''}
                </ButtonContainer>
                <MenuTitle marginbottom={30}>{menuTitle}</MenuTitle>
                <Menu>
                    <div>
                        <NavItems list={menuStack.length ? activeMenu : menu} />
                    </div>
                    {activeImage && <NavImage src={activeImage} />}
                </Menu>
            </InnerContainer>
        </NavigationWrap>
    )
}

const OuterContainer = styled.div`
    width: 85px;
    position: relative;
`

const InnerContainer = styled.div`
    width: 81%;
    height: 100%;
    padding: 0 40px;
`

const NavImage = styled.div`
    background: url(${({ src }) => src}) center/cover no-repeat;
    width: 40%;
    height: 0;
    padding-bottom: 56.25%;
    border: 10px solid white;
`

const ButtonContainer = styled.div`
    display: flex;
    margin-bottom: 30px;
`

const BackButton = styled(Button)`
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 10px 15px 9px;
`

const CloseButton = styled.div`
    width: 40px;
    height: 40px;
    background: url('/static/images/sprite.svg') no-repeat  -79px -78px;
    border: 1px solid ${colors.white};
    border-radius: 50%;
    margin-right: 10px;
    cursor: pointer;
`

const NavigationWrap = styled.nav`
    display: flex;
    flex-direction: row;
    /* justify-content: space-between; */
    background: ${colors.red};
    height: 100vh;
    width: calc(75vw + 50px);
    /* cursor: pointer; */
    position: fixed;
    left: 0;
    flex: 1;
    padding: 4vh 2vw;
    background: ${colors.pink};
    color: ${colors.white};
    
    @media ${devices.small} {
        width: 100%;
        padding: 1vh 4vw;
        flex-direction: column;
    }

    @media ${minDevices.medium} {
        z-index: 0;
    }
`

const Menu = styled.div`
    display: flex;
    justify-content: space-between;

    @media (max-width: 1450px) {
        
    }

    @media ${devices.small} {
        padding: 30px 0 0 0;
        margin-bottom: auto;
    }
`

const NavItem = styled.div`
    font-size: 26px;
    cursor: pointer;
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    text-decoration: none;
    color: ${colors.white};
    margin-bottom: 10px;

    &:after {
        content: '';
        display: block;
        background: url('/static/images/sprite.svg') no-repeat -85px -55px;
	    width: 23px;
	    height: 20px;
        margin-left: 20px;
        opacity: 0;
        transition: all 0.2s ease-in;
    }

    &:hover {
        &:after {
            opacity: 1;
        }
    }

    @media ${devices.small} {
        font-size: 45px;
        padding-left: 0;
        margin-bottom: 0;
        padding-bottom: 20px;
    }
`

const MenuButton = styled.div`
    display: flex;
    height: 32px;
    cursor: pointer;
    margin-left: -1vw;
    color: ${colors.white};
    visibility: ${({ open }) => open ? 'hidden' : 'visible'};

    > div {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 35px;
        height: 35px;

        > div {
            height: 3px;
            margin: 3px 0;
            background: ${colors.white};
        }
    }

    @media ${devices.small} {
        height: 21px;

        > div {
            height: 21px;
        }
    }
`

const MenuTitle = styled(UpperHeader)`
`